import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule} from "../shared/shared.module";
import { DocusignRoutingModule } from './docusign-routing.module';
import {DocusignFailComponent} from "./docusign-fail/docusign-fail.component";
import {DocusignSuccessComponent} from "./docusign-success/docusign-success.component";


@NgModule({
  declarations: [
    DocusignFailComponent,
    DocusignSuccessComponent
  ],
  imports: [
    CommonModule,
    DocusignRoutingModule,
    SharedModule
  ]
})
export class DocusignModule { }
